/* Minizz : rangée « Complète ton colis » du tiroir panier (snippets/minizz-complements.liquid), 31/10/2026, thème v19l. */
(function () {
  if (window.__mzCpl) return;
  window.__mzCpl = true;
  var doux = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function fleches(row) {
    var t = row.querySelector('[data-mz-cpl-track]');
    if (!t) return;
    var max = t.scrollWidth - t.clientWidth;
    row.classList.toggle('mz-cpl--defile', max > 4);
    var p = row.querySelector('[data-mz-cpl-dir="-1"]');
    var n = row.querySelector('[data-mz-cpl-dir="1"]');
    if (p) p.disabled = t.scrollLeft <= 4;
    if (n) n.disabled = t.scrollLeft >= max - 4;
  }
  function toutes() {
    document.querySelectorAll('[data-mz-cpl]').forEach(fleches);
  }

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.nodeType === 1 && t.hasAttribute('data-mz-cpl-track')) {
      var row = t.closest('[data-mz-cpl]');
      if (row) fleches(row);
    }
  }, true);

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-mz-cpl-dir], [data-mz-cpl-add]') : null;
    if (!el) return;
    var row = el.closest('[data-mz-cpl]');
    if (!row) return;
    e.preventDefault();

    if (el.hasAttribute('data-mz-cpl-dir')) {
      var t = row.querySelector('[data-mz-cpl-track]');
      if (!t) return;
      var sens = parseInt(el.getAttribute('data-mz-cpl-dir'), 10) || 1;
      t.scrollBy({ left: sens * Math.max(150, Math.round(t.clientWidth * 0.8)), behavior: doux ? 'smooth' : 'auto' });
      return;
    }

    if (el.disabled) return;
    var id = parseInt(el.getAttribute('data-variant-id'), 10);
    if (!id) return;
    var err = row.querySelector('.mz-cpl__error');
    var boutons = row.querySelectorAll('[data-mz-cpl-add]');
    Array.prototype.forEach.call(boutons, function (b) { b.disabled = true; });
    el.classList.add('is-loading');
    if (err) { err.hidden = true; err.textContent = ''; }

    var drawer = document.querySelector('cart-drawer');
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
    }
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sections.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) {
        return r.json().then(function (res) {
          if (!r.ok || res.status) throw new Error(res.description || res.message || 'add');
          return res;
        });
      })
      .then(function (res) {
        if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
          drawer.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        Array.prototype.forEach.call(boutons, function (b) { b.disabled = false; });
        el.classList.remove('is-loading');
        if (err) { err.textContent = 'Ajout impossible pour le moment.'; err.hidden = false; }
      });
  });

  var minuteur = null;
  function plusTard() { clearTimeout(minuteur); minuteur = setTimeout(toutes, 150); }
  function demarrer() {
    toutes();
    var dr = document.querySelector('cart-drawer');
    if (dr && window.MutationObserver) new MutationObserver(plusTard).observe(dr, { childList: true, subtree: true });
    window.addEventListener('resize', plusTard);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();